import Animals from '@/views/Animals.vue'
import AnimalsSearch from '@/modules/animals/AnimalsSearch.vue'
import AnimalDetails from '@/modules/animals/AnimalDetails.vue'

import { ANIMALS_STORE_NAMESPACE } from '@/modules/animals/animalsStore'

export default [
  {
    path: '/animals',
    component: Animals,

    children: [
      {
        path: '',
        name: 'animalsSearch',
        components: {
          master: AnimalsSearch
        },

        props: {
          master: route => ({
            animalsStorePath: ANIMALS_STORE_NAMESPACE,
            category: route.query.category
          })
        }
      },
      {
        path: ':animalId',
        name: 'animalDetails',
        components: {
          master: AnimalsSearch,
          details: AnimalDetails
        },

        props: {
          master: route => ({
            animalsStorePath: ANIMALS_STORE_NAMESPACE,
            category: route.query.category
          }),
          details: route => ({
            animalsStorePath: ANIMALS_STORE_NAMESPACE,
            animalId: route.params.animalId
          })
        }
      }
    ]
  }
]
